import { Component, h } from 'preact';

class TcrUserTile extends Component
{
    constructor(props)
    {
        super(props);

        this.credentialsUpdated = this.credentialsUpdated.bind(this);

        this.state = this.getState(props);
    }

    componentWillReceiveProps(props)
    {
        this.setState(this.getState(props));
    }

    getState(props)
    {
        return {
            expanded: false,
            initials: props.initials,
            title: props.title,
            subtitle: props.subtitle,
            actions: props.actions || [],
            login: {}
        };
    }


    credentialsUpdated(login)
    {
        this.setState({login: login});
    }

    toggle(e)
    {
        this.setState({expanded: !this.state.expanded});
    }

    runAction(a)
    {
        this.setState({expanded: false});
        if (typeof a === 'function')
        {
            a();
        }
    }

    onFocusOut()
    {
        this.setState({
            expanded: false
        });
    }

    render()
    {
        if (!this.props.visibility) return null;

        let actions = (this.state.actions || []).map(a =>
        {
            return <div class="item" onClick={() => this.runAction(a.action)}>{a.label}</div>;
        });

        //<div class="icon" style={{backgroundColor: this.props.accent}}></div>

        return (
            <div class="user-tile" data-expanded={this.state.expanded} tabindex="0" onFocusOut={this.onFocusOut.bind(this)}>
                <div class="upper_container" onClick={this.toggle.bind(this)} >
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM134.2 107.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3c-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z"/></svg>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/></svg>
                    </div>
                    <div class="mail">{this.props.subtitle}</div>
                    <div class="name">{this.props.title}</div>
                </div>
                {actions}
            </div>
        );
    }
}

export { TcrUserTile };
